import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as bulkAction from "../../../../redux/actions/bulk.action";
import { useTranslation } from "react-i18next";
import List from "../../../list/list";
import { formatDate } from "../../../../helpers/date";

const bulkFields = [
  //list will sort by the first element by default
  "name",
  "description",
  "name",
  "type",
];
const BulkList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { bulks, meta, listLoading } = useSelector((state) => ({
    bulks: state.bulk.bulkList,
    meta: state.bulk.bulkMetadata,
    listLoading: state.bulk.listLoading,
  }));

  useEffect(() => {
    bulkAction.fetchAll(dispatch);
  }, [dispatch]);

  return (
    <List
      redirect="/bulk/form"
      title={t("bulks.bulks")}
      isOverview={false}
      columnNames={[
        "NAME",
        "DESCRIPTION",
        "LINK NAME",
        "TYPE",
        "CREATION DATE",
      ]}
      entities={bulks?.data?.map(
        ({
          id,
          attributes: { type, name, description, link_name, createdAt },
        }) => ({
          id,
          type,
          link_name,
          columns: [
            { primary: name },
            { primary: description },
            { primary: link_name },
            { primary: type },
            { primary: formatDate(createdAt) },
          ],
        })
      )}
      fieldsToSort={bulkFields}
      fetchAction={(params) => bulkAction.fetchAll(dispatch, params)}
      metadata={meta}
      isEditable={true}
      tooltipTextDelete="Delete Bulk"
      hasListModal={true}
      deleteAction={(id, params) => bulkAction.remove(dispatch, id, params)}
      loading={listLoading}
    />
  );
};

export default BulkList;
